<script setup lang="ts">
import { useDialog } from 'primevue/usedialog'

const appStore = useAppStore()
const { cartRoute } = useMcdRoutes()
const { t } = useLocale()
const { format } = useFormatAmount()
const dialog = useDialog()
const { trackGoCart } = useGTM()

const emit = defineEmits(['overlay-closed'])

const products = computed(() => appStore.cart.products)
const closeOverlay = () => {
  trackGoCart()
  emit('overlay-closed')
}

/* Confirmation clear cart */
const clearCart = async () => {
  const deleteConfirmation = await showDialogAlert({
    dialog,
    data: {
      title: t('shoppingCart.alerts.clear.title'),
      body: t('shoppingCart.alerts.clear.body'),
      btnPrimary: t('shoppingCart.alerts.clear.accept'),
      btnSecondary: t('shoppingCart.alerts.clear.cancel'),
      headerImage: '/images/icons/mcd-bag.svg',
    },
  })
  if (deleteConfirmation) appStore.clearCart(true)
}
</script>

<template>
  <div class="flex h-fit w-[26rem] flex-col justify-between gap-0 bg-white shadow-elevation-up">
    <header>
      <div class="flex w-full flex-row items-center justify-between px-6 py-4">
        <CloseIcon width="14.5" height="14.5" class="z-[11] cursor-pointer" @click="closeOverlay" />

        <a
          v-if="products.length"
          class="cursor-pointer text-sm text-mcd-secondaryBlue underline"
          @click.prevent.stop="clearCart"
        >
          {{ t('shoppingCart.actions.clear') }}
        </a>
      </div>
    </header>

    <section
      class="flex h-[30svh] flex-col items-center justify-center"
      :class="{ '!justify-start': products.length }"
    >
      <!-- Empty cart -->
      <div
        v-if="!products.length"
        class="mx-auto flex flex-col items-center justify-between gap-4 px-6"
      >
        <img class="h-auto md:w-1/2" src="/images/icons/empty-bag.svg" alt="empty" />
        <h4 class="text-center font-bold md:text-lg">{{ t('shoppingCart.empty.title') }}</h4>
        <p class="text-center text-sm">
          {{ t('shoppingCart.empty.text') }}
        </p>
        <div class="min-h-[3.25rem] w-full"></div>
      </div>
      <!-- Products component -->
      <div v-else class="mcd-custom-scrollbar w-full overflow-y-auto">
        <CartProducts container-class="px-6" mobile @click-navigate="closeOverlay" />
      </div>
    </section>

    <!-- total full row -->
    <div
      v-if="products.length"
      class="mt-4 flex w-full flex-row items-center justify-between bg-mcd-secondaryIvory px-8 py-4 text-2xl font-bold text-mcd-black"
    >
      <p>
        {{ t('shoppingCart.total') }}
      </p>
      <span class="block">{{ format(appStore.cartTotal) }}</span>
    </div>
    <NuxtLink :to="cartRoute()" @click.prevent="closeOverlay">
      <McdButton is-primary class="h-14 w-full rounded-none">
        {{ t('shoppingCart.actions.seeCart') }}
      </McdButton>
    </NuxtLink>
  </div>
</template>
